/* @ngInject */
function flagIconDirective(cdnDomain: string): Record<string, any> {
	return {
		restrict: "A",
		scope: {
			countryCode: "=flagIconCountry"
		},
		link: function (scope, element, attrs) {
			function applySrc() {
				// A missing country code is the normal case, not an error: every flag-icon usage is
				// tennis-only (PlayerData.player1/2.country) and sits inside an ng-show block, and
				// ng-show still links the directive and keeps its $watch alive for non-tennis matches
				// where PlayerData is undefined. An else branch here logged ~36 false positives per
				// widget load and buried real console errors.
				if (scope.countryCode) {
					attrs.$set("src", `${cdnDomain}/images/flagsquares/${scope.countryCode.toUpperCase()}.png`);
				}
			}

			applySrc();
			scope.$watch("countryCode", applySrc);
		}
	};
}

export default flagIconDirective;